module.exports = __webpack_public_path__ + "static/Icon_Transparent_Background-38f82ef30db7a9a25879ee59a44c777e.png";